import { shouldPollForUpdates, type PollCheckItem } from '@mimir/client-common/util/searchHitsPolling';
import type { SearchResultHit } from '@mimir/common/dto/searchResultHit';
import type { CompleteType } from '@mimir/common/util/general';
import { isDeleting } from '@mimir/common/dto/itemModels';
import { searchState } from '@mimir/web/globals/searchState';
import { getGlobalStore } from './index';

let searchPageVisible = false;

export function getSearchPageVisible() {
  return searchPageVisible;
}

export function setSearchPageVisible(b: boolean) {
  searchPageVisible = b;
  if (!searchPageVisible) {
    // If we move away from the search page, let's reset the list of items to poll
    getGlobalStore().commit('setItemsToPoll', []);
  } else {
    // If we show the search page, let's initialize the items to poll
    pollSearchHitsIfNeeded();
  }
}

export function pollSearchHitsIfNeeded() {
  const store = getGlobalStore();
  const hits = searchState.reactive.itemSearch.results.hits as SearchResultHit[];
  const progressingHits = hits.filter(h => shouldPollForUpdates(toPollItem(h)));
  // Since store.state.search.itemSearch.results.hits contains all the hits we currently have,
  // let's set the items to poll by filtering from this list all the items that should be polled.
  //
  // Note that we use setItemsToPoll and not addItemsToPoll because that would accumulate
  // items to poll without clearing items that are no longer in the search hits (for instance, if
  // we had a search for videos and the user has switched to search for images, we should stop polling
  // the previous video items)
  store.commit('setItemsToPoll', progressingHits.map(hit => hit.id));
}

function toPollItem(item: SearchResultHit): CompleteType<PollCheckItem> {
  return {
    progressInfo: item.progressInfo,
    itemState: item.itemState,
    isLive: item.isLive ?? false,
    transcodingState: item.transcodingState ?? undefined,
    isDeleting: isDeleting(item),
  };
}
